<template>
  <el-form :model="updateForm" :loading="loading">
    <el-form-item label="验证码" required>
      <div style="display: flex">
        <el-input style="width: 15rem" placeholder="请输入验证码" v-model="updateForm.smsCode"/>
        <el-button style="margin-left: 1rem" type="primary" @click="sendSMSCode" :disabled="smsCodeCountDownSecond > 0">{{smsCodeCountDownSecond > 0?('' + smsCodeCountDownSecond) :'发送验证码'}}</el-button>
      </div>
      </el-form-item>
    <el-form-item label="新密码" required>
      <div style="display: flex">
        <el-input style="width: 15rem" placeholder="请输入新密码" :show-password="true" v-model="updateForm.newPassword"/>
      </div>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submit">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {sendResetPswSMSCode, updatePswBySMSCode} from './loginApi'

export default {
  name: 'updateBySmsCode',
  data () {
    return {
      loading: false,
      smsCodeCountDownSecond: -1,
      updateForm: {
        smsCode: '',
        newPassword: ''
      }
    }
  },
  methods: {
    startCountDown () {
      const stopTimer = () => {
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      }
      stopTimer()
      this.smsCodeCountDownSecond = 60
      this.timer = setInterval(() => {
        this.smsCodeCountDownSecond = this.smsCodeCountDownSecond - 1
        if (this.smsCodeCountDownSecond < 0) {
          stopTimer()
        }
      }, 1000)
    },
    sendSMSCode () {
      sendResetPswSMSCode().then(rsp => {
        this.loading = false
        const {code, message} = rsp
        if (code === 0) {
          this.$message.success('发送成功')
          this.startCountDown()
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    submit () {
      if (this.updateForm.smsCode.trim().length === 0) {
        this.$message.error('验证码不能为空')
        return false
      }
      if (this.updateForm.newPassword.trim().length === 0) {
        this.$message.error('新密码不能为空')
        return false
      }
      this.loading = true
      updatePswBySMSCode(this.updateForm).then(rsp => {
        this.loading = false
        const {code, message} = rsp
        if (code === 0) {
          this.$message.success('修改成功')
          this.$emit('success')
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Login/updateBySmsCode.vue